export default function AlertBar(element) {
    if (!element) {
        return;
    }
    else {
        const closeButton = element.querySelector(".c-alert-bar__button");

        if (element.open) {
            closeButton?.addEventListener("click", () => {
                element.close?.();
            });
        }
    }
}
